import {
  filterKeys,
  userCategoryOptions,
  sortByOptions,
  topicsOptions,
} from '../../constants/filterOptions'

const initialFilter = {
  [filterKeys.searchText]: '',
  [filterKeys.price]: 0,
  [filterKeys.currentPage]: 1,
  [filterKeys.userCategory]: userCategoryOptions.find(d => d.default),
  [filterKeys.sortBy]: sortByOptions.find(d => d.default),
  [filterKeys.topic]: topicsOptions.find(d => d.default),
}
const initialState = {
  isLoading: false,
  filter: {
    ...initialFilter,
  },
  filterOptions: {
    [filterKeys.topic]: [topicsOptions.find(d => !!d.default)],
  },
  courses: [],
  results: [],
  error: '',
  totalPages: 0,
  isFiltered: false,
}

const allCourses = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOADING_COURSES':
      return { ...state, isLoading: true }
    case 'FETCH_ALL_COURSES':
      return {
        ...state,
        isLoading: true,
        courses: [],
        results: [],
      }
    case 'SET_ALL_COURSES':
      return {
        ...state,
        courses: action.payload.data,
        results: action.payload.data,
        totalPages: action.payload.lastPage,
        isLoading: false,
        isFiltered: false,
      }
    case 'SET_COURSES_FILTER_OPTIONS':
      return {
        ...state,
        filterOptions: { ...state.filterOptions, ...action.payload },
      }
    case 'SET_COURSES_FILTER_RESULTS':
      return {
        ...state,
        isFiltered: true,
        filter: { ...state.filter, ...action.payload.filter },
      }
      case 'SET_COURSES_PAGE':
      return {
        ...state,
        filter: { ...state.filter, ...action.payload.filter },
      }
    case 'CLEAR_COURSES_FILTER':
      return {
        ...state,
        filter: { ...state.filter, ...initialFilter },
        results: state.courses,
      }
    default:
      return { ...state }
  }
}
export default allCourses